import { render, staticRenderFns } from "./AppSlices.vue?vue&type=template&id=79b062f8"
import script from "./AppSlices.vue?vue&type=script&lang=ts"
export * from "./AppSlices.vue?vue&type=script&lang=ts"
import style0 from "./AppSlices.vue?vue&type=style&index=0&id=79b062f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports